import React, {useContext} from 'react'

export type ModalComponent<T> = React.ComponentType<T>
export type ModalProps<T> = T
export type Modal<T = any> = {component: ModalComponent<T>; props: ModalProps<T>}

export type ModalsStateContextProps = {
  modal: Modal | null
}

export type ModalsActionsContextProps = {
  open: <T>(component: ModalComponent<T>, props: ModalProps<T>) => void
  close: () => void
}

export const ModalsActionsContext = React.createContext<ModalsActionsContextProps>(null as any)
export const ModalsStateContext = React.createContext<ModalsStateContextProps>(null as any)

export function useModalsStateContext() {
  return useContext(ModalsStateContext)
}

export function useModalsActionsontext() {
  return useContext(ModalsActionsContext)
}
